export type StockSheetFileKind = "image" | "pdf" | "excel" | "csv" | "word";

/** Classify upload for /api/parse-stock-sheet routing (vision vs document vs spreadsheet). */
export function detectStockSheetFileKind(fileName: string, mime: string): StockSheetFileKind {
  const m = (mime || "").toLowerCase().trim();
  const ext = (fileName.split(".").pop() || "").toLowerCase();

  if (m.startsWith("image/")) return "image";
  if (m === "application/pdf" || ext === "pdf") return "pdf";
  if (ext === "csv" || m === "text/csv" || m === "application/csv") return "csv";
  if (
    ext === "xlsx" ||
    ext === "xls" ||
    m.includes("spreadsheetml") ||
    m === "application/vnd.ms-excel" ||
    m === "application/vnd.ms-excel.sheet.macroenabled.12"
  ) {
    return "excel";
  }
  if (
    ext === "docx" ||
    m === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return "word";
  }
  if (ext === "doc" || m === "application/msword") return "word";
  return "image";
}
